import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const PageHero = ({ eyebrow, title, subtitle, children, accent }) => {
  const reduce = useReducedMotion();
  const rise = (delay) => ({
    initial: reduce ? { opacity: 0 } : { opacity: 0, y: 22 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease: EASE },
  });

  return (
    <section className="relative overflow-hidden border-b border-brand-border">
      {/* Background grid + radial gleam */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          aria-hidden="true"
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage:
              "linear-gradient(to right, rgba(47,61,30,0.5) 1px, transparent 1px), linear-gradient(to bottom, rgba(47,61,30,0.5) 1px, transparent 1px)",
            backgroundSize: "64px 64px",
            maskImage:
              "radial-gradient(ellipse at 30% 0%, black 30%, transparent 70%)",
            WebkitMaskImage:
              "radial-gradient(ellipse at 30% 0%, black 30%, transparent 70%)",
          }}
        />
        <motion.div
          aria-hidden="true"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.4, ease: EASE }}
          className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, rgba(122,142,74,0.18), transparent 60%)",
            filter: "blur(20px)",
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 lg:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8">
            {eyebrow && (
              <motion.div
                {...rise(0)}
                className="inline-flex items-center gap-2.5 rounded-full border border-brand-olive/40 bg-brand-accent/10 pl-3 pr-4 py-1.5"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-brand-olive" />
                <span className="text-[11px] font-semibold tracking-[0.22em] uppercase text-brand-olive">
                  {eyebrow}
                </span>
              </motion.div>
            )}
            <motion.h1
              {...rise(0.1)}
              className="font-display mt-7 text-4xl sm:text-5xl lg:text-[4rem] lg:leading-[1] text-brand-deep font-medium leading-[1.05] tracking-[-0.025em]"
            >
              {title}
            </motion.h1>
            {subtitle && (
              <motion.p
                {...rise(0.22)}
                className="mt-8 max-w-2xl text-brand-warm text-lg sm:text-xl leading-relaxed font-light"
              >
                {subtitle}
              </motion.p>
            )}
            {children && (
              <motion.div {...rise(0.34)} className="mt-10">
                {children}
              </motion.div>
            )}
          </div>

          {accent && (
            <motion.div {...rise(0.46)} className="lg:col-span-4">
              <div className="border-l border-brand-olive/40 pl-6 text-sm text-brand-muted leading-relaxed font-light">
                {accent}
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
